{
  "address": {
    "streetAddress": "Street address (number and street)",
    "enterManually": "Enter address manually",
    "useAutocomplete": "Use address autocomplete",
    "missingNumber": "Add the street number to complete this address.",
    "copyToReturn": "Also use these details for the return address",
    "googleAttribution": "Google Maps"
  },
  "attachmentUpload": {
    "computerSubtitle": "Add a file from this computer.",
    "photoTitle": "Add photos",
    "documentTitle": "Add documents",
    "subtitle": "Add a file from this computer or generate a QR code to add it from a mobile device.",
    "qrSubtitle": "Scan this QR code with a mobile device to add the attachment.",
    "fileLabel": "Add your attachment",
    "mobile": "From your phone or tablet",
    "computer": "From your computer",
    "maxFiles": "Up to {count} files",
    "partial": "Some files could not be uploaded. Only the failed files remain selected; retry them.",
    "fromComputer": "From computer",
    "viaMobile": "Via mobile",
    "loadFailed": "Unable to load the mobile upload link.",
    "retry": "Try again",
    "missing": "The file has not been uploaded yet.",
    "confirm": "Confirm upload"
  },
  "publicPage": {
    "loading": "Loading…",
    "invalidTitle": "Expired or invalid link",
    "invalidMessage": "Request a new link or QR code from the file, or contact the sender.",
    "failedTitle": "Unable to load the page",
    "failedMessage": "The page could not be loaded. Check your connection and try again.",
    "retry": "Try again"
  },
  "publicUpload": {
    "or": "or",
    "browse": "browse your files",
    "maxSize": "Maximum size {size} {unit}",
    "tooLarge": "This file exceeds the maximum allowed size.",
    "replacePhoto": "Replace photo",
    "invalidFormat": "This file format is not accepted."
  },
  "notAuthorized": "Not authorized",
  "noData": "No data",
  "noValue": "-",
  "notProvided": "Not provided",
  "exportScheduled": "Export scheduled. You will receive the file by email.",
  "currency": {
    "euro": "€"
  },
  "units": {
    "kilogram": "kg",
    "wattHour": "Wh",
    "centimeter": "cm",
    "tonne": "t",
    "volt": "V",
    "ampereHour": "Ah",
    "byte": "B",
    "kilobyte": "KB",
    "megabyte": "MB"
  },
  "percent": "%",
  "tax": {
    "excluding": "excl. VAT"
  },
  "datePlaceholder": "DD/MM/YYYY",
  "loading": "Loading...",
  "buttons": {
    "confirm": "Confirm",
    "retry": "Retry",
    "back": "Back",
    "cancel": "Cancel",
    "validate": "Validate",
    "detail": "Detail",
    "update": "Update",
    "delete": "Delete",
    "add": "Add",
    "remove": "Remove"
  },
  "yes": "Yes",
  "no": "No",
  "filter": {
    "search": "Search",
    "showFilters": "Show filters",
    "export": "Export",
    "clearFilters": "Clear filters"
  },
  "inputs": {
    "otherSelected": "+ {count} other selected",
    "othersSelected": "+ {count} others selected"
  },
  "navigation": {
    "dashboard": "Home",
    "keyAccountProducts": "Product park",
    "repairFiles": "Repair files",
    "users": "Users",
    "transporters": "Transporters",
    "profile": "Profile",
    "environmentalPerformanceReport": "Environmental performance analysis",
    "help": "Help",
    "logout": "Logout"
  }
}
